import { render, staticRenderFns } from "./ClaimFilter.vue?vue&type=template&id=339d0b49&"
import script from "./ClaimFilter.vue?vue&type=script&lang=js&"
export * from "./ClaimFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports